// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2496":"9a507da5","5818":"9a507da5","6147":"9a507da5","6993":"83369341","7445":"6dadd03a"}[chunkId] + ".chunk.css";
};